export { default } from './component'
export {
  ClassesTooltip,
  GradeTooltip,
  LastLessonTooltip,
  LessonProgressTooltip,
  MarkedDoneTooltip,
  TableHeaderTooltip,
} from './component.styles'
